"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyTotal = void 0;
function makeEmptyTotal() {
    return {
        subTotal: 0,
        tax: 0,
        taxRate: 0,
        grandTotal: 0,
        discounts: [],
    };
}
exports.makeEmptyTotal = makeEmptyTotal;
//# sourceMappingURL=Total.js.map